import Loadable from 'react-loadable';

import { LoadableLoadingPage } from './LoadableLoadingPage';

export const GradProgramPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "gradSchools/GradProgramPageContainer" */
      './GradProgramPageContainer'
    ),
  loading: LoadableLoadingPage,
});
